import React from 'react';
import Highlighter from 'react-highlight-words';

import OverflowText from '~/components/OverflowText';
import grid from '~/styles/grid';

import { Container, ValueContent } from './styles';

export interface ItemDetailProps {
  label: string;
  value: string;
  className?: string;
  highlighterProps?: {
    searchWords: Array<string>;
    sanitize: (search: string) => string;
  };
  icon?: JSX.Element;
}
export type VariableWithIcon = Omit<ItemDetailProps, 'highlighterProps'>;
export type Variable = Pick<ItemDetailProps, 'value' | 'label'>;

const LABEL_CSS = {
  fontSize: '85.71%',
  color: '#999999',
  opacity: 0.8,
  marginBottom: grid.xs,
};
const VALUE_CSS = {
  color: '#1a1a1a',
  fontSize: '100%',
};

const ItemDetail: React.FC<ItemDetailProps> = ({
  label,
  value,
  icon,
  highlighterProps,
  className,
}) => {
  return (
    <Container className={className}>
      <OverflowText title={label} lines={1}>
        <Highlighter
          style={LABEL_CSS}
          activeIndex={-1}
          autoEscape
          searchWords={highlighterProps?.searchWords ?? []}
          textToHighlight={label}
          sanitize={highlighterProps?.sanitize}
        />
      </OverflowText>
      <ValueContent>
        {icon}
        <OverflowText title={value} lines={3}>
          <Highlighter
            style={VALUE_CSS}
            activeIndex={-1}
            autoEscape
            searchWords={highlighterProps?.searchWords ?? []}
            textToHighlight={value}
            sanitize={highlighterProps?.sanitize}
          />
        </OverflowText>
      </ValueContent>
    </Container>
  );
};

export default ItemDetail;
